<div class="level-up-strategy">
  <h4>Hitpoints when leveling up</h4>
  <ul>
    <li *ngFor="let strat of availableStrategies"
        class="interactive"
        [innerText]="strat"
        [class.selected]="strat === strategy"
        [class.disabled]="strat.toString() === 'Die roll'"
        (click)="selectStrategy(strat)"
    ></li>
  </ul>
</div>
